import * as React from 'react'

interface ISearchOptions {
  label: string
  value: string
}

interface ISearchFilterProps {
  placeholder: string
  items: ISearchOptions[]
  name: string
  selections: string[]
}

interface IFilterItemsProps {
  items: ISearchOptions[]
  name: string
  onFilterSelect: (e: any) => void
  selections: string[]
}

const FilterItems = (props: IFilterItemsProps) => {
  return (
    <React.Fragment>
      {props.items.map(({ label, value }) => (
        <div key={`search_filter_${value}`} className='mb2'>
          <input
            type='checkbox'
            name={props.name}
            value={value}
            checked={props.selections.includes(value)}
            id={`search_filter_${value}`}
            className='mr1'
            onChange={props.onFilterSelect}
          />
          <label htmlFor={`search_filter_${value}`} className='font-grey h5'>
            {label}
          </label>
        </div>
      ))}
    </React.Fragment>
  )
}

class SearchFilter extends React.Component<ISearchFilterProps, any> {
  constructor(props: ISearchFilterProps) {
    super(props)

    this.state = {
      searchVal: ''
    }
  }

  public render() {
    return (
      <div>
        <div>
          <input
            className='rounded p1 border-light-grey4 mb2'
            placeholder={this.props.placeholder}
            value={this.state.searchVal}
            onChange={this.onSearchChange}
          />
        </div>
        <div>{this.fitlerItems()}</div>
      </div>
    )
  }

  private fitlerItems = () => {
    const searchString = new RegExp(this.state.searchVal)
    return (
      <FilterItems
        items={this.props.items.filter(({ value }) => searchString.test(value))}
        onFilterSelect={this.onFilterSelect}
        name={this.props.name}
        selections={this.props.selections}
      />
    )
  }

  private onSearchChange = (e: any) => {
    this.setState({ searchVal: e.target.value })
  }

  private onFilterSelect = (e: any) => {
    //TODO remove filter from seletion
  }
}

export default SearchFilter



// WEBPACK FOOTER //
// ./src/components/ui/SearchFilter.tsx